<template>
  <MainLayout section="gateway">
    <b-container fluid id="gateways-container" v-bind:class="$mq">
      <b-row>
        <b-col lg=4 id="primary-subsection">
          <h2 style="text-decoration: underline">Gateways</h2>

          <div class="spinner_container" v-if="loading">
            <b-spinner />
          </div>

          <ul id="gateways_list" v-bind:class="$mq">
            <li v-for="gateway in gateways"
                v-bind:key="gateway.gateway"
                v-on:click="select(gateway)"
                class="gateway_link"
                v-bind:class="is_selected(gateway) ? 'selected' : ''">
              <span>{{gateway.text}}</span>
              <span class="expand_gateway_obligations">➤</span>
            </li>
          </ul>
        </b-col>

        <template v-if="!!selected">
          <b-col lg=7 class="secondary-subsection" v-bind:class="$mq">
              <h2 id="obligations_title">
                <AccountLink v-bind:account="selected.id" />
              </h2>

              <span v-if="have_kyg" class="kyg_link" v-b-modal.kyg>KYG</span>

              <div style="clear: both"></div>

              <div style="font-size: 0.8rem; margin-bottom: 5px"><b>{{selected.id}}</b></div>

              <h4 style="background-color: #D5D5D5; padding: 5px; margin-top: 20px">Obligations</h4>

              <ul id="obligations_list">
                <li v-for="obligation in selected.obligations"
                    class="gateway_obligation"
                    v-bind:key="obligation.currency">
                  <span><b>{{obligation.currency | ellipsis(10)}}</b></span>
                  <span class="obligation_amount">{{Math.abs(obligation.balance) | round | delim}}</span>
                </li>
              </ul>
          </b-col>
        </template>

        <template v-else>
          <b-col lg=7 id="info-subsection"
                      class="secondary-subsection"
                      v-bind:class="$mq">
            <h3 id="kyg_title">Know Your Gateway</h3>

            <p class="info_text">
            Gateways are the institutions that manage and allocate all non-native assets on the XRP Ledger
            </p>

            <img id="kyg_clipart" :class="$mq" src="./assets/usd-gateway.jpg" />

            <p class="info_text">
            Here you can find out information about well-known gateways along with outstanding obligations
            </p>
          </b-col>
        </template>
      </b-row>
    </b-container>

    <b-modal id="kyg" ok-only size='lg'>
      <KnowYourGateway v-bind:gateway="selected_kyg" />
    </b-modal>
  </MainLayout>
</template>

<script>
import config from './config'
import tags from './tags'

import MainLayout  from './components/MainLayout.vue';
import AccountLink from './components/AccountLink.vue'
import KnowYourGateway from './components/KnowYourGateway.vue'

function load_kyg(vue){
  var context = require.context('./assets/gateways', true, /.json$/);
  context.keys().forEach(function(k){
    var gw = k.replace("./", "").replace(".json", "");
    vue.kygs[gw] = context(k);
  });
}

function get_obligations(vue){
  vue.$http.get(config.DATA_URI + "/gateways/obligations")
           .then(function(response){
             vue.gateways = Object.keys(response.body).map(function(gw){
               return {
                          id : gw,
                        text : tags.tags_for(gw)[0] || gw,
                 obligations : response.body[gw]
               }

             }).sort(function(gw1, gw2) {
               var n1 = gw1.text.toLowerCase();
               var n2 = gw2.text.toLowerCase();
               return n1 > n2 ?  1:
                      n1 < n2 ? -1: 0;
             });
           });
}

export default {
  name: 'Gateways',

  components: {
    MainLayout,
    AccountLink,
    KnowYourGateway
  },

  data : function(){
    return {
      gateways : [],
      selected : null,
      kygs : {}
    }
  },

  computed : {
     loading : function(){
       return this.gateways.length == 0;
     },

    selected_kyg : function(){
      if(!this.selected) return null;
      return this.kygs[this.selected.text.replace(/ /g, "")];
    },

    have_kyg : function(){
      return !!this.selected_kyg;
    }
  },

  methods : {
    select : function(gw){
      this.selected = gw;
    },

    is_selected : function(gw){
      return this.selected == gw;
    }
  },

  mounted : function(){
           load_kyg(this);
    get_obligations(this);
  }
}
</script>

<style scoped>
#gateways-container{
  padding: 50px;
  margin: 0;
  height: 100%;
  background: #eef1f6;
}

#primary-subsection{
  border: 1px solid black;
  border-radius: 5px;
  padding-top: 25px;
  padding-bottom: 5px;
  background: white;
  align-self: baseline;
}

.secondary-subsection{
  border: 1px solid black;
  border-radius: 5px;
  margin-left: 50px;
  padding-top: 25px;
  padding-bottom: 5px;
  padding-left: 25px;
  background: white;
}

.secondary-subsection.md,
.secondary-subsection.sm{
  margin-left: 0;
  margin-top: 25px;
}

#gateways_list{
  max-height: 500px;
  overflow-y: auto;
  list-style-type: none;
  padding-left: 15px;
}

#gateways_list.md,
#gateways_list.sm{
  max-height: 300px;
  border: 1px solid black;
  padding: 5px;
}

.gateway_link{
  padding: 10px;
}

.gateway_link:hover{
  cursor: pointer;
  background-color: orange;
}

.gateway_link.selected{
  background-color: blue;
  color: white;
}

.expand_gateway_obligations{
  float: right;
  margin-right: 15px;
}

.kyg_link{
  float: right;
  color: blue;
  cursor: pointer;
}

#obligations_title{
  margin-bottom: 0;
  float: left;
}

#obligations_list{
  list-style-type: none;
  padding-left: 15px;
  overflow: auto;
}

.gateway_obligation{
  padding: 10px;
}

.obligation_amount{
  float: right;
  background-color: red;
  color: white;
  min-width: 200px;
  text-align: center;
  padding: 5px;
  border-radius: 15px;
}

#info-subsection{
  display: flex;
  flex-direction: column;
}

#kyg_title{
  text-decoration: underline;
  text-align: center;
}

#kyg_clipart{
  display: block;
  margin: auto;
  padding: 20px;
}

#kyg_clipart.lg{
  margin-top: 20px;
}

.info_text{
  text-align: center;
}
</style>
